export default __webpack_public_path__ + "static/media/hyper.06a7b10a.svg";